<!--
@component Switch between two options, a simplified selector with logical value.

   Main properties:
   - `options` - array with two options (strings), first for `true`, second for `false`.
   - `value` - the selected value, default: `false`.
-->
<script>
   import Select from './Select.svelte';

   let {
      options = ["no", "yes"],         // array with all options
      value = $bindable(false),        // initial selected value
   } = $props();

   let selectValue = $state(true);

   const cleanOptions = $derived.by(() => {
      if (options.length != 2) {
         console.error('Switch: parameter "option" must gave two values.');
         return null;
      }

      return options;
   });

   $effect(() => selectValue = value ? options[1] : options[0])
   $effect(() => value = selectValue === options[1]);
</script>

{#if cleanOptions}
<Select options={cleanOptions} bind:value={selectValue} />
{/if}